import { render, staticRenderFns } from "./TpvKo.vue?vue&type=template&id=b02e3a4a&"
import script from "./TpvKo.vue?vue&type=script&lang=js&"
export * from "./TpvKo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports